import { httpClient } from '../httpClient';
export class ContractRepository {
    // 契約情報取得
    async getContract() {
        const { data } = await httpClient.get(`contract/fetch`);
        return data;
    }
    // 付帯契約情報一覧取得
    async getSubContractList() {
        const { data } = await httpClient.get(`contract/subcontract/fetch`);
        return data;
    }
    // 付帯契約情報取得
    async getSubContract(params) {
        const { data } = await httpClient.get(`contract/subcontract/${params.subContractId}/fetch`);
        return data;
    }
    // 契約者情報変更（連絡先変更）
    async changeContract(params) {
        const { data, status } = await httpClient.post(`customer/info-change`, JSON.stringify(({ telNo: params.telNo, email: params.email } = params)));
        if (status !== 201) {
            if (status === 411) {
                alert('入力内容に誤りがあります。再度入力してください。');
            }
            else {
                alert('エラーが発生しました。再度やり直してください。');
            }
            throw Error();
        }
        return data;
    }
    async requestQueBacklog(params) {
        const { data } = await httpClient.post(`contract/request-que-backlog`, JSON.stringify(({
            processCategoryCode: params.processCategoryCode,
            changeDate: params.changeDate,
            changeInfo: params.changeInfo,
            contactDate1: params.contactDate1,
            contactDate2: params.contactDate2,
            contactDate3: params.contactDate3
        } = params)));
        return data;
    }
    // 契約解約依頼
    async terminateContractRequest(params) {
        const { data, status } = await httpClient.post(`contract/${params.contractId}/terminate/request`, JSON.stringify(({} = params)));
        if (status !== 201) {
            throw Error();
        }
        return data;
    }
    // 契約解約
    async terminateContract(params) {
        const { data } = await httpClient.post(`contract/terminate`, JSON.stringify(({
            terminateTypeCode: params.terminateTypeCode,
            terminateReasonCode: params.terminateReasonCode,
            terminateReasonDetail: params.terminateReasonDetail
        } = params)));
        return data;
    }
    // 副契約解約
    async terminateSubContract(params) {
        const { data, status } = await httpClient.post(`contract/subcontract/${params.subContractId}/indivisual/terminate`, JSON.stringify({}));
        if (status !== 201) {
            throw Error();
        }
        return data;
    }
    // プラン変更依頼状況取得
    async getPlanChangeStatus() {
        const { data } = await httpClient.get(`contract/plan/change/status`);
        return data;
    }
    // 変更可能なサービスマスタ一覧取得
    async getChgMstServcieList(params) {
        const { data } = await httpClient.get(`contract/mst-service/change/${params.mstServiceId}/fetch`);
        return data;
    }
    // プラン変更予約作成
    async registerPlanChange(params) {
        const { data } = await httpClient.post(`contract/plan/change/request/${params.mstServiceCode}`);
        return data;
    }
    // プラン変更予約キャンセル
    async cancelPlanChange() {
        const { data } = await httpClient.put(`contract/plan/change-cancel/request`);
        return data;
    }
    // 一時停止（UMOBILE_D）
    async suspend(params) {
        const { data } = await httpClient.post(`contract/sim/suspend/`, JSON.stringify(({ accountId: params.accountId, suspendReasonCode: params.suspendReasonCode } = params)));
        return data;
    }
    // 一時停止（PREMIUM）
    async suspendPremium(params) {
        const { data } = await httpClient.post(`contract/sim/suspend/premium`, JSON.stringify(({ accountId: params.accountId, suspendReasonCode: params.suspendReasonCode } = params)));
        return data;
    }
    // 一時停止再開（UMOBILE_D）
    async reopen(params) {
        const { data } = await httpClient.post(`contract/sim/reopen/`, JSON.stringify(({ accountId: params.accountId } = params)));
        return data;
    }
    // 一時停止再開（PREMIUM）
    async reopenPremium(params) {
        const { data } = await httpClient.post(`contract/sim/reopen/premium`, JSON.stringify(({ accountId: params.accountId } = params)));
        return data;
    }
    // データ残量取得
    async getDataTrafficRemain() {
        const { data } = await httpClient.get(`contract/datatrafficremain`);
        return data;
    }
    // 月別データ通信量取得 ※UmobileEa,UmobileSonet向け
    async getMonthlyDataTrafficRouter() {
        const { data } = await httpClient.get(`contract/monthly-data-traffic/router/fetch`);
        return data;
    }
    /** 請求金額確定通知取得 */
    async getMonthlySubscriptionInfoType() {
        const { data } = await httpClient.get(`contract/monthly-subscription-info-type/fetch`);
        return data;
    }
    /** 請求金額確定通知更新 */
    async changeMonthlySubscriptionInfoType(params) {
        const { data } = await httpClient.put(`contract/monthly-subscription-info-type/change`, JSON.stringify(params));
        return data;
    }
    // 光01用移設依頼
    async requestHikari01Transfer(params) {
        const { data } = await httpClient.post(`contract/transfer/hikari01/request`, JSON.stringify(({ constructionCost: params.constructionCost, hopeDate: params.hopeDate } = params)));
    }
    // 光01 ごと解約
    async terminateHikari01Contract(params) {
        const { data } = await httpClient.post(`contract/hikari01-terminate/`, JSON.stringify(({
            terminateDate: params.terminateDate,
            terminateTypeCode: params.terminateTypeCode,
            terminateReasonCode: params.terminateReasonCode,
            terminateReasonDetail: params.terminateReasonDetail
        } = params)));
        return data;
    }
    // 光01 違約金
    async fetchHikari01Penalty() {
        const { data } = await httpClient.get(`contract/hikari01-penalty/fetch`);
        return data;
    }
}
